var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEraser = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.03047 11.9688C3.73672 12.2625 3.73672 12.7375 4.03047 13.0281L6.28047 15.2781C6.42109 15.4188 6.61172 15.4969 6.81172 15.4969H10.1898C10.3898 15.4969 10.5805 15.4188 10.7211 15.2781L12.7523 13.2469L7.74922 8.25002L4.03047 11.9688ZM9.90859 3.96877C10.7867 3.09065 12.2117 3.09065 13.0898 3.96877L17.0305 7.9094C17.9086 8.78752 17.9086 10.2125 17.0305 11.0906L12.6211 15.5H17.2492C17.6648 15.5 17.9992 15.8344 17.9992 16.25C17.9992 16.6656 17.6648 17 17.2492 17H10.2492C10.2305 17 10.2086 17 10.1898 17H6.81172C6.21484 17 5.64297 16.7625 5.22109 16.3406L2.97109 14.0906C2.09297 13.2125 2.09297 11.7875 2.97109 10.9094L9.90859 3.96877Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEraser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "0bf546bfdd1fe2c2e47e63ab67e9ccc8.svg";